<template>
  <div class="moHome">
    <router-view></router-view>
  </div>

</template>

<script>
export default {
  name: "noHome"
}
</script>

<style scoped>
.moHome{
  height: 100%;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/mobile/moHome.vue